// ©2024 Austin App House. All rights reserved.
import { isEmailValid, isNameSymbolsOnly } from '../../validators';

const contractorBankingInformationOnSubmit = (values) => {
  const result = {};

  // if (!values.bankName || !values.bankName.trim()) {
  //   result.bankName = 'Please enter Bank Name';
  // }

  if (!isEmailValid(values.email)) {
    result.email = 'Please enter valid Email';
  }

  // if (!values.name || values.name.trim() === '') {
  //   result.name = 'Please enter Account Owner Name';
  // } else
  //  if (!isNameSymbolsOnly(values.name)) {
  //   result.name = 'The Account Owner Name can only contain letters and characters "-" and "."';
  // } else if (values.name.trim() !== values.name) {
  //   result.name = 'The Account Owner Name can\'t start or end with spaces';
  // }

  if (!values.routing || !values.routing.trim()) {
    result.routing = 'Please enter Routing';
  }
  if (values.routing && values.routing.length !== 9) {
    result.routing = 'Routing number must be 9 digits';
  }

  if (!values.account || !values.account.trim()) {
    result.account = 'Please enter Account';
  }

  // if (!values?.accountType?.value) {
  //   result.accountType = 'Please select Account Type';
  // }

  // if (!values?.accountStatus?.value) {
  //   result.accountStatus = 'Please select Account Status';
  // }

  if (!values.acceptTerms) {
    result.acceptTerms = 'Please agree to terms & policies';
  }

  return result;
};

export default contractorBankingInformationOnSubmit;
